import React from 'react'
import SidebarItem, { ISecondGroup } from './sidebar-item'
import Tianxing from '@/assets/images/tianxing.svg'

import './sidebar.scss'

import { getBEMCls } from '@/utils/classname'
import { useHistory } from 'react-router'
import { GOODS_GOODS_LIBRARY } from '../../modules/goods-manage/goods-storage/router'
import { GOODS_SUPPLIER } from '../../modules/goods-manage/purchase-manage/router'
import { GOODS_JOIN_STOCK } from '../../modules/goods-manage/stock-manage/router'
import { MALL_GOODS_SHELF } from '../../modules/mall-manage/mall-shelf/router'
import { STAFF_LIST } from '../../modules/staff-manage/router'
import { ORDER_CASHIER } from '../../modules/order-manage/router'
import { GOODS_SALE_CHART } from '../../modules/data-manage/router'
import { PICTURE_MATERIAL_PATH } from '../../modules/material-manage/router'
import { AI_ASSISTANT_PATH } from '../../modules/ai-assistant/constants'
import { MEMBER_LIST, MEMBER_RECHARGE_RECORD, MEMBER_SETTING_BASIC } from '../../modules/member-manage/router'
import { SETTING_CASHIER_CONFIG, SETTING_SHOP_INFO } from '../../modules/setting-manage/router'
import { MARKETING_HOME } from '../../modules/marketing-manage/router'
import { observer } from 'mobx-react'
import { staffStore } from '@/store/staff'

interface ISidebarConfig {
    id: number
    icon: string
    iconImg?: string
    activeIcon?: string
    activeImg?: string
    path?: string
    title: string
    count?: number
    onClick?: () => void
    secondGroup?: ISecondGroup[]
    permission?: number
}

const Sidebar = observer(() => {
    const getCls = (el?: string, moder?: string) => getBEMCls('sidebar', el, moder)

    const history = useHistory()

    /**
     * 一级分组id从0依次排序
     * 二级分组id以一级分组id + 二级分组顺序id 如 2 + 11 =》 211
     */
    const sidebarConfig: ISidebarConfig[] = [
        {
            id: 11,
            icon: '',
            iconImg:
                'https://img.senguo.cc/assets/pf/ai-assistant/avatar/20260710/v1/ai-avatar-person-nav-wave-loose.webp',
            path: 'ai-assistant',
            title: 'AI助手',
            onClick: () => {
                history.replace(AI_ASSISTANT_PATH)
            },
        },
        {
            id: 2,
            icon: 'icon1jingyingshujuguan-24',
            activeIcon: 'icon1jingyingshujukai-24',
            path: 'data',
            permission: 3,
            title: '经营数据',
            onClick: () => {
                history.replace(GOODS_SALE_CHART)
            },
        },
        {
            id: 1,
            icon: 'icon1weishangchengguan-24',
            activeImg: Tianxing,
            path: 'mall',
            title: '微商城',
            secondGroup: [
                {
                    id: 41,
                    title: '商城货架',
                    secondPath: 'mallShelf',
                    onClick: () => {
                        history.replace(MALL_GOODS_SHELF)
                    },
                },
            ],
        },
        {
            id: 4,
            icon: 'icon1shangpinguan-24',
            activeIcon: 'icon1shangpinkai-24',
            title: '商品',
            path: 'goods',
            secondGroup: [
                {
                    id: 41,
                    title: '商品库',
                    secondPath: 'goodStorage',
                    onClick: () => {
                        history.replace(GOODS_GOODS_LIBRARY)
                    },
                },
                {
                    id: 42,
                    title: '采购管理',
                    secondPath: 'purchaseManage',
                    onClick: () => {
                        history.replace(GOODS_SUPPLIER)
                    },
                },
                {
                    id: 43,
                    title: '库存管理',
                    secondPath: 'stockManage',
                    onClick: () => {
                        history.replace(GOODS_JOIN_STOCK)
                    },
                },
            ],
        },
        {
            id: 5,
            icon: 'icon1dingdanguan-24',
            activeIcon: 'icon1dingdankai-24',
            path: 'order',
            title: '订单',
            onClick: () => {
                history.replace(ORDER_CASHIER)
            },
        },
        {
            id: 6,
            icon: 'icon1huiyuanguan-24',
            activeIcon: 'icon1huiyuankai-24',
            path: 'member',
            permission: 4,
            title: '会员',
            secondGroup: [
                {
                    id: 61,
                    title: '会员列表',
                    secondPath: 'list',
                    activeSecondPaths: ['detail'],
                    onClick: () => {
                        history.replace(MEMBER_LIST)
                    },
                },
                {
                    id: 62,
                    title: '充值记录',
                    secondPath: 'rechargeRecord',
                    onClick: () => {
                        history.replace(MEMBER_RECHARGE_RECORD)
                    },
                },
                {
                    id: 63,
                    title: '会员设置',
                    secondPath: 'setting',
                    activeSecondPaths: [
                        'group',
                        'birthday',
                        'bindingRecord',
                        'cardRecord',
                        'levelChangeRecord',
                        'level',
                        'import',
                    ],
                    onClick: () => {
                        history.replace(MEMBER_SETTING_BASIC)
                    },
                },
            ],
        },
        {
            id: 7,
            icon: 'icon1yuangongguan-24',
            activeIcon: 'icon1yuangongkai-24',
            title: '员工',
            path: 'staff',
            onClick: () => {
                history.replace(STAFF_LIST)
            },
        },
        {
            id: 8,
            icon: 'icon1yingxiaowanfaguan-24',
            activeIcon: 'icon1yingxiaowanfakai-24',
            path: 'marketing',
            title: '营销玩法',
            onClick: () => {
                history.replace(MARKETING_HOME)
            },
        },
        {
            id: 9,
            icon: 'icon1sucaikuguan-24',
            activeIcon: 'icon1sucaikukai-24',
            path: 'material',
            title: '素材库',
            onClick: () => {
                history.replace(PICTURE_MATERIAL_PATH)
            },
        },
        {
            id: 10,
            icon: 'icon1dianpushezhiguan-24',
            activeIcon: 'icon1dianpushezhikai-24',
            path: 'setting',
            title: '店铺设置',
            permission: 5,
            secondGroup: [
                {
                    id: 101,
                    title: '店铺信息',
                    secondPath: 'shopInfo',
                    onClick: () => {
                        history.replace(SETTING_SHOP_INFO)
                    },
                },
                {
                    id: 102,
                    title: '收银台设置',
                    secondPath: 'cashier',
                    onClick: () => {
                        history.replace(SETTING_CASHIER_CONFIG)
                    },
                },
            ],
        },
    ]

    return (
        <div className={getCls()}>
            {sidebarConfig
                .filter(item => !item.permission || staffStore.canIUse(item.permission))
                .map((item: ISidebarConfig) => (
                    <SidebarItem
                        key={item.id}
                        icon={item.icon}
                        iconImg={item.iconImg}
                        iconActive={item.activeIcon}
                        imgActive={item.activeImg}
                        id={item.id}
                        secondGroup={item.secondGroup}
                        title={item.title}
                        count={item.count}
                        path={item.path}
                        onClick={item.onClick}
                    />
                ))}
        </div>
    )
})

export default Sidebar
